import React from "react";
import { LinkTo } from "../../../CommonComponents/commonStyles";
import PropTypes from 'prop-types';

const HyperLinkComponent = ({ className, to, text }) => {
  return (
    <LinkTo className={className} href={to}> {text} </LinkTo>
  )
}

HyperLinkComponent.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
}

export default HyperLinkComponent;